import API from '@/api';
const Cases = API.get('Cases');
const Request = API.get('Request');

export default ({
  namespaced: true,
  state: {
    total: 0,
    cases: [],
    pages: 0,
    teleconsultation: null,
    prescription: null,
    certificate: null,
    laboratory: null,
    id: null, // current case id
    data: null // current case

  },
  getters: {
    total: state => state.total,
    cases: state => state.cases,
    pages: state => state.pages,
    teleconsultation: state => state.teleconsultation,
    prescription: state => state.prescription,
    certificate: state => state.certificate,
    laboratory: state => state.laboratory,
    id: state => state.id,
    data: state => state.data
  },
  mutations: {
    setCasesInfo(state, data) {
      state.total = data.total
      state.cases = data.cases
      state.pages = data.pages
    },
    updateCaseList(state, cases) {
      state.cases = cases
    },
    setFiles(state, data) {
      state.teleconsultation = data.file_careplan
      state.prescription = data.file_prescription
      state.certificate = data.file_medical_certificate
      state.laboratory = data.file_laboratory
    },
    setCase(state, data) {
      state.data = data
    },
    setCaseId(state, id) {
      state.id = id
    }
  },
  actions: {
    async getCompletedCases({ commit }, { page=1, update=null, status='completed' }) {
      var response = await Cases.get(null, null, status, page);
      var data = {
        cases: response.data.data,
        total: response.data.total,
        pages: response.data.last_page
      }
      if (update)
        commit('updateCaseList', data.cases)
      else
        commit('setCasesInfo', data)
    },
    async generateCaseFiles({ commit }, id) {
      const payload = {
        case_consultation_id: id,
        has_careplan: 1,
        has_laboratory: 1,
        has_medical_certificate: 1,
        has_prescription: 1,
        laboratory_tests: []
      }
      let response = await Request.create(payload);
      console.log("[request/generate]", response.data, payload);

      commit('setFiles', response.data)
    },
    async getCaseRequest({ commit, dispatch }, id) {
      let response = await Cases.get(id);
      console.log('[case]', id, response.data)
      commit('setCase', response.data)
      var consultations = response.data.consultations
      let index = consultations.length - 1
      var consultation = consultations[index]

      if (consultation.requests.length) {
        var requests = consultation.requests
        let index = requests.length - 1
        let request = requests[index]
        console.log("[latest-request]", request);

        var files = [
          request.file_careplan,
          request.file_prescription,
          request.file_medical_certificate,
          request.file_laboratory
        ]

        if (files.includes(null)) {
          console.log('[has-null-files]', files)
          dispatch('generateCaseFiles', consultation.id)
        }
        else {
          console.log('[complete-files]', files)
          commit('setFiles', request)
        }
      }
      else {
        console.log('[no-request-found]', consultation)
        dispatch('generateCaseFiles', consultation.id)
      }
    },
    async getCase({ commit }, id) {
      var response = await Cases.get(id);
      commit('setCase', response.data)
    },
  }
})